const spreadDetail = ['保养说明', '质检说明', '运输说明', '退换货说明']


module.exports = {
  clean: (data) => {
    data._address = null
    data.unavailable = false
    clean_rush(data)
    clean_forecast(data)
    spvs_sort(data)
    clean_price(data)
    clean_presell(data)
  },
  cleanDetail: (item) => {
    let reTag = /<(?:.|\s)*?>/g
    let styleAttr = /style="[^"]*"/g
    let remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g

    let _content = item.content.replace(styleAttr, "").replace( remoeveTable, "")
    let _content_arr = _content.split('</p>')
    _content_arr.forEach((__content ,index)=>{
      _content_arr[index] = __content.replace(reTag,"").replace(/&nbsp;/ig, "")
    })

    item._content = _content_arr
    item._spreadAll = false
    item._spread = false
    spreadDetail.some((detail) => {
      item._spreadAll = true
      if(item.title.trim() === detail) {
        item._spreadAll = false
        return true
      }
    })
    return item
  },
  get_variant_data :(product)=>{
    let _product = product
    let _pack = {
      product: {
        pic: _product.featureImage,
        brand: _product.brand,
        name: _product.name,
        rawPrice: _product.rawPrice,
        price: _product.price
      },
      variant: _product.variant.spvs[0].id,
      count: _product.variant.spvs[0].minAmount
      // labels: _product.labels
    }

    return {
      selectAmount: true,
      pack: _pack,
      spvId: _product.variant.spvs[0].id,
      variant: _product.variant,
      count: _product.variant.spvs[0].minAmount
    }
  },
  deepCopy(target){ 
    let copyed_objs = [];//此数组解决了循环引用和相同引用的问题，它存放已经递归到的目标对象 
      function _deepCopy(target){ 
        if((typeof target !== 'object')||!target){return target;}
        for(let i= 0 ;i<copyed_objs.length;i++){
            if(copyed_objs[i].target === target){
                return copyed_objs[i].copyTarget;
            }
        }
        let obj = {};
        if(Array.isArray(target)){
            obj = [];//处理target是数组的情况 
        }
        copyed_objs.push({target:target,copyTarget:obj}) 
        Object.keys(target).forEach(key=>{ 
            if(obj[key]){ return;} 
            obj[key] = _deepCopy(target[key]);
        }); 
        return obj;
    } 
    return _deepCopy(target);
  } 
}

function clean_price(product){
  let _price = {
    price:{},
    rawPrice:{}
  },
  _variant = product.variant,
  //根据spv的价格排序过的数据
  min = _variant.spvsSort[0],
  priceMin = min && min.price,
  rawPriceMin = min && min.rawPrice
  _price.price['min'] = priceMin
  _price.rawPrice['min'] =rawPriceMin

  if(_variant.spvsSort.length>1){
    let max = _variant.spvsSort[_variant.spvsSort.length-1],
        priceMax = max && max.price,
        rawPriceMax = max && max.rawPrice;
    _price.price['max'] = priceMax
    _price.rawPrice['max'] =rawPriceMax
  }
  product.format_price = _price
}

function clean_presell(product){
  let _presell = product.presell
  if (_presell) {
    let date = new Date(_presell.deliverAt)
    _presell.text = `该商品预售，预计将于${zero_plus(date.getMonth()+1)}月${zero_plus(date.getDate())}日开始发货`
  }
}

function zero_plus (num){
  return num>=10 ? num : `0${num}`
}

function spvs_sort(product){
  let _variant = product.variant
  _variant.spvsSort = _variant.spvs
  _variant.spvsSort.sort((a,b) => {
    return  a.price - b.price
  })
}

function clean_forecast(product){
  let _forecast = product.priceForecast
  if(!_forecast){
    return false
  }
  let _range = _forecast.range
  if(_range.length>1){
    _forecast._price = _range[0] === _range[1]
                          ? `¥${_range[0]}`
                          : `¥${_range[0]}-¥${_range[1]}`
  }else{
    _forecast._price = `¥${_range[0]}`
  }
  let date = new Date(_forecast.since)
  _forecast._since = `${zero_plus(date.getMonth()+1)}月${zero_plus(date.getDate())}日
                        ${zero_plus(date.getHours())}:${zero_plus(date.getMinutes())}生效`
}

function clean_rush(product){
  let spvs = product.variant.spvs
  let firstFlash = spvs && spvs.length ? spvs[0].flashSale : null
  let rush = {}
  // console.log('spvs',spvs)
  // if(spvs.length==1){
  //   if(firstFlash){
  //     rush.flashSale = firstFlash
  //     rush._djs = firstFlash.expiresAt
  //   }
  //   return false
  // }
  // console.log(1)
  rush.state = spvs.some((spv) => {
    return spv.flashSale && spv.flashSale !== null
  })
  rush.notAll = spvs.some((spv) => {
    return spv.flashSale && spv.flashSale === null
  })
  
  if(rush.state){
    const _spv = spvs.filter(spv => {
      return spv.flashSale && spv.flashSale !== null && spv.left > 0
    })[0]
   
    if (!_spv) return
    rush.flashSale = _spv.flashSale
    rush._djs = _spv.flashSale.expiresAt
  }
  product._rush = rush
}


// WEBPACK FOOTER //
// ./static/app-product-detail/util.js